import React, { useEffect, useState } from "react";
//import axios from '../../../node_modules-back/axios';
//import axios from 'axios'
//import { useForm } from '../../../node_modules-back/react-hook-form/dist';
//import { useForm } from 'react-hook-form';
import { Form } from 'react-bootstrap';
//import { getUrl } from "../../ApiCall/GetUrl";

import { useLocation, useNavigate } from "react-router-dom";


import Footer from "../Footer/Footer";
// Importación de los estilos
import "./PagoAux.css"

import { ApiCallPost } from "../../ApiCall/ApiCall";

function year() {
  let arr = [];
  for (let i = 2000; i < 2026; i++) {
    arr.push(i);
  }
  return arr;
}


function month() {

  let arr = [];
  for (let i = 1; i < 13; i++) {
    arr.push(i);
  }
  return arr;
}




export default function PagoAux() {
  //const [registrado, setRegistrado] = useState(false)
  const [state,setState] = useState( null )

  const [registrado,setRegistrado] = useState( null )

  const location = useLocation() ;

  console.log( "En pagos " , location)

  //setRegistrado( location.state.logg_express )
  const navigate = useNavigate() ;

  useEffect(() => {

    
      // console.log( "Dentro de pagos " , {state : { id :  location.state.id , 
      //   logg_express : !registrado , especialidad_express : location.state.especialidad_express , 
      //   comentario_express : document.getElementById("description").value , 
      //   estado_express : location.state.estado_express , name : location.state.name ,   date_express : new Date() }} )

        //setRegistrado( location.state.logg_express )

    

    //setState( location.state )
  }, [])


  function onMeetingStop()
  {
    console.log( "onMeetingStop ...")

    ApiCallPost( "/meetingstop" , { id : state?.id  } )
    .then( response =>{

      if ( response === "ok")
      {
        alert("Se ha detenido la reunion")
        return ;
      }

    })
    .catch((error)=>{

        console.log( error)

      }
    )
  }

  function onMeeting(e)
{

    e.preventDefault() ; // Ya no recarga la pagina

    console.log( "id = " +  location.state.id )

    //return ; 

    //ApiCallPost( "/lawyer_set_agenda" , { id : location.state.is , status : !registrado })

    ApiCallPost( "/client_set_agenda" , { id : location.state.id , 
           logg_express : true  /* !registrado */, especialidad_express : location.state.especialidad_express , 
           comentario_express : location.state.comentario_express , estado_express : location.state.lugar ,  date_express : new Date() } )
      .then( (res) => {
  
          console.log( "Respuesta " ,  res )
  
          if ( res.status === 0 )
          {
              // if ( registrado === false )
              // {
              //   alert("Consulta Express registrada")
              // }
              // else{
              //   alert("Consulta Express eliminada")
              // }
              
              setRegistrado( !registrado )

              window.open( 'https://conference.legaltek.digital/?name=' + location.state.name , '_blank')
              
          }
  
      })
      .catch( (err) => {
  
          console.log( err )
          alert("Error al registrar la consulta express")
  
  
      })
  

      //window.open( 'https://conference.legaltek.digital/?name=' + state?.name , '_blank')


      
    
  
}


  return <>
    <div className="contenedor">
      <div className="mt-5 mb-5">
        <p className="ml-auto">
          ENTER YOUR CARD DETAILS
        </p>
        <div classNam e="d-flex">
          <div className="container m-auto auxiliar">
            <Form onSubmit={onMeeting}>
              <div className="row mt-5 ">
                <div className="col">
                  <input placeholder="CARD NUMBER" className="estilo_input"></input>
                </div>
              </div>
              <div className="row mt-5 ">
                <div className="col">
                  <select className="productos-select">
                    <option value="" disabled selected hidden>MONTH</option>

                    {
                      month().map((row,index) =>
                        <option key={index}>{row}</option>
                      )
                    }
                  </select>
                </div>
                <div className="col">
                  <select className="productos-select">
                    <option value="" disabled selected hidden>YEAR</option>
                    {
                      year().map((row,index) =>
                        <option key={index}>{row}</option>
                      )
                    }
                  </select>
                </div>
              </div>

              <div className="row mt-5 ">
                <div className="col">
                  <input placeholder="CARD HOLDER" className="estilo_input"></input>
                </div>
              </div>
              <div className="row mt-5 ">
                <div className="col">
                  <input placeholder="CVV2 SECURITY CODE" className="estilo_input"></input>
                </div>
              </div>
              <div className="row mt-3 ">
                  <button type="submit" className="btn btn-primary " onClick={onMeeting}>Pagar</button>
              </div>

              <div className="row mt-3 ">
                  <button  className="btn btn-secondary " onClick={onMeetingStop}>Detener</button>
              </div>

            </Form>
          </div>
        </div>
      </div>
      
    </div>
    <Footer oscuro={true} />
  </>

}